<template>
  <div class="mt-5 row">
    <div class="mx-auto col-lg-9 col-xs-12">
      <b-breadcrumb :items="items"></b-breadcrumb>

      <div class="card p-3">
        <div class="card-body">
          <div class="form-group">
            <label for="nome">Nome do Paciente:</label>

            <div>
              <input
                id="nome"
                type="text"
                :class="`form-control`+($v.nome.$error ? ` is-invalid` : ``)"
                name="nome"
                placeholder="Nome e sobrenome"
                v-model="$v.nome.$model"
                @change="$v.nome.$touch()"
                @keyup.enter="buscaPedidos"
                autocomplete
                required
                autofocus
              />
            </div>
            <div class="error" v-if="$v.nome.$error">
              <div v-if="!$v.nome.required">
                <small>Este campo é obrigatório.</small>
              </div>
              <div v-if="!$v.nome.minLength">
                <small>Este campo deve possuir no mínimo {{$v.nome.$params.minLength.min}} caracteres.</small>
              </div>
              <div v-if="!$v.nome.alphaSpaces">
                <small>Este campo deve possuir apenas letras.</small>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="nome">Número do Pedido:</label>

            <div>
              <input
                id="nuped"
                type="text"
                :class="`form-control`+($v.nuped.$error ? ` is-invalid` : ``)"
                name="nuped"
                placeholder="Apenas números"
                v-model.trim="$v.nuped.$model"
                @change="$v.nuped.$touch()"
                @keyup.enter="buscaPedidos"
                autocomplete
                required
                autofocus
              />
            </div>
            <div class="error" v-if="$v.nuped.$error">
              <div v-if="!$v.nuped.required">
                <small>Este campo é obrigatório.</small>
              </div>
              <div v-if="!$v.nuped.minLength">
                <small>Este campo deve possuir no mínimo {{$v.nuped.$params.minLength.min}} caracteres.</small>
              </div>
              <div v-if="!$v.nuped.numeric">
                <small>Este campo aceita apenas valores numéricos.</small>
              </div>
            </div>
          </div>

          <button
            :disabled="!captcha_token"
            type="submit"
            @click="buscaPedidos"
            class="btn btn-primary btn-block"
          >Entrar</button>
        </div>
      </div>
    </div>

    <div class="text-center">
      <b-spinner label="Spinning"></b-spinner>
      <b-spinner type="grow" label="Spinning"></b-spinner>
      <b-spinner variant="primary" label="Spinning"></b-spinner>
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
      <b-spinner variant="success" label="Spinning"></b-spinner>
      <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
    </div>
  </div>
</template>

<script>
import { recaptchaToken } from '../helpers/index.js'
import { required, minLength, numeric, helpers } from "vuelidate/lib/validators"

export default {
  data() {
    return {
      nome: "",
      nuped: "",
      items: [{ text: "Busca pedido", active: true }]
    };
  },
  validations: {
    nome: {
      required,
      alphaSpaces: helpers.regex('alphaSpaces', /^[a-zA-Z0-9 ]*$/),
      minLength: minLength(3)
    },
    nuped: {
      required,
      numeric,
      minLength: minLength(12)
    }
  },
  computed: {
    http() {
      return this.$store.getters.http
    },
    captcha_token() {
      return this.$store.getters.token
    }
  },
  methods: {
    async buscaPedidos() {
      this.$store.dispatch("flushMsgs", 'msgs')
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.$Progress.start();
        let token = await recaptchaToken(this.$env.VUE_APP_GOOGLE_RECAPTCHA_KEY)        
        this.$store.dispatch('gravaToken', token)
        this.http
          .get(`/busca-pedidos/${this.nome}/${this.nuped}`, { params: { token } })
          .then(res => {
            this.$store.dispatch("gravaDadosForm", {
              nome: res.data.dados[0].NOUSU,
              nuped: res.data.dados[0].NUPED
            })
            this.$store.dispatch("gravaListaPedidos", res.data.dados)

            this.$Progress.finish()
            this.$router.push({ name: "lista-pedidos" })

          })
          .catch(async (err) => {
            this.$Progress.fail()
            let msg = err && err.response && err.response.data && err.response.data.message 
            msg = msg.token || msg
            if(msg.token) {
              token = await recaptchaToken(this.$env.VUE_APP_GOOGLE_RECAPTCHA_KEY)
              this.$store.dispatch('gravaToken', token)
            } 
            msg = msg || `Não foi possível recuperar o pedido. Tente novamente em instantes.`
            this.$store.dispatch('addErro', {ref: "msgs", msg})
          });
      }
    },
  },
  async mounted() {
    this.$store.dispatch("flushDados")
    this.$store.dispatch("flushMsgs", "msgs")
  },
};
</script>

<style scoped>
.error {
  color: #dc3545;
}
</style>